'use strict';
const angular = require('angular');

/*@ngInject*/
export function IntegrationService($resource) {
  return $resource('/api/integrations/:id', {
    id: '@_id'
  },{
    suiteUpdateEVotingConsent: {
      method: 'PUT',
      url: "/api/integrations/suite/e-voting-consent/:contactId"
    },
    suiteGetEVotingConsent: {
      method: 'GET',
      url: "/api/integrations/suite/e-voting-consent/:contactId"
    },
    suiteActivatedWebAccess: {
      method: 'PUT',
      url: "/api/integrations/suite/activate-webaccess/:webaccessId"
    },
    suiteGetWebAccessEmail: {
      method: 'GET',
      url: "/api/integrations/suite/webaccess-email/:webaccessId/:token"
    },
    suiteResetPassword: {
      method: 'PUT',
      url: "/api/integrations/suite/webaccess-reset-password"
    },
  });
}

export default angular.module('conduu.IntegrationService', [])
  .factory('IntegrationService', IntegrationService)
  .name;



// WEBPACK FOOTER //
// ./client/components/integration/integration.service.js